export default __webpack_public_path__ + "static/media/NORLYSHeadline-Bold.909d03cf.woff";